var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sounds),function(sound,index){return _c('button',{key:index,class:{
      'active': _vm.isActive(sound.file)
    },on:{"click":function($event){return _vm.onClick(sound.file)}}},[_vm._v(" "+_vm._s(sound.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }